<template>
  <nav id="navbar-header" class="navbar navbar-expand navbar-dark">
    <router-link :to="{ name: 'index' }" class="navbar-brand">
      <img src="@/assets/images/logo-sar.png" alt="SAR" />
      <span>Início</span>
    </router-link>

    <div class="navbar-collapse" id="navbar-collapse">
      <template v-if="authenticated">
        <admin-menu v-if="selected_control_panel == 'admin'"></admin-menu>
        <operational-menu v-else></operational-menu>

        <ul class="navbar-nav ms-auto">
          <company-dropdown></company-dropdown>
          <order-of-service-dropdown></order-of-service-dropdown>
          <user-dropdown></user-dropdown>
        </ul>
      </template>
    </div>
  </nav>
</template>

<script>
  import AdminMenu from './AdminMenu.vue'
  import CompanyDropdown from './CompanyDropdown.vue'
  import OrderOfServiceDropdown from './OrderOfServiceDropdown.vue'
  import OperationalMenu from './OperationalMenu.vue'
  import UserDropdown from './UserDropdown.vue'

  import { computed } from 'vue'
  import { useStore } from 'vuex'

  export default {
    name: 'AppNavbar',
    components: {
      AdminMenu,
      CompanyDropdown,
      OrderOfServiceDropdown,
      OperationalMenu,
      UserDropdown,
    },
    setup() {
      const store = useStore()
      const authenticated = computed(() => store.getters.authenticated)
      const selected_control_panel = computed(() => store.getters.selected_control_panel)
      return { authenticated, selected_control_panel }
    },
  }
</script>
